module.exports = __webpack_public_path__ + "img/truck-location.e1a60f80.svg";